import { getArchiveReflowList, getReflowProgress, startArchiveReflow } from '../services';

export default {
  namespace: 'fileReflux',
  state: {},
  effects: {
    *getArchiveReflowList({ payload }, { call }) {
      const res = yield call(getArchiveReflowList, payload);
      return res;
    },

    *getReflowProgress({ payload }, { call }) {
      const res = yield call(getReflowProgress, payload);
      return res;
    },

    *startArchiveReflow({ payload }, { call }) {
      const res = yield call(startArchiveReflow, payload);
      return res;
    },
  },
};
